
module.directive('americorpsHoursForm', function(moment, ModelConfig, ModelService) {
    var fields = ['days_suspended', 'hours', 'hours_distribution', 'canceled']
    return {
        restrict: 'E',
        templateUrl: 'students/americorps/americorpsHoursForm',
        scope: {slot: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = ModelService.copyFields(scope.slot, fields)
            scope.form = basicForm.getForm();
            scope.hoursDistributionOptions = ModelConfig.getOptions('hours_distribution');;
            addWatchers(moment, scope, 'slot.amc_enrollment_date',
                                       'data.days_suspended',
                                       'data.hours');
            basicForm.save = function(data) {
                return ModelService.patchModel(scope.slot, data)
            };
        },
    };
});


module.cC({
    name: 'AmericorpsSlotController',
    inject: ['$scope', 'slot', 'ModelConfig', 'moment', 'ModelService', '$state'],
    data: {
        slot: 'slot',
        slotTypes: 'ModelConfig.getOptions("slot_type")',
    },

    watch: {
        'slot.slot_type': '_setHoursOptions',
    },

    init: function() {
        addWatchers(this.moment, this.$, 'slot.amc_enrollment_date',
                                         'slot.days_suspended',
                                         'slot.hours');
    },

    methods: {
        deleteSlot: function() {
            return this.ModelService.deleteModel(this.slot)
                .then(this.$state.go.bind(this.$state, '^.index'));
        },

        slotLabel: function(slot) {
            return [slot.grant_year, this.slotTypes[slot.slot_type], 'Slot']
                .join(' ');
        },

        _setHoursOptions: function(slot_type) {
            var distribution = this.ModelConfig.getOptions("hours_distribution");
            this.$.hoursOptions = distribution[slot_type] || distribution.default;
        },
    }
});


module.directive('amcHoursTracker', function($timeout, moment) {

    return {
        restrict: 'E',
        templateUrl: 'students/americorps/amcHoursTracker',
        scope: {
            startDate: '=',
            hours: '=',
            expectedHours: '=',
            daysSuspended: '=',
            edAwardEarned: '=',
        },
        link: function(scope, element, attrs) {
            var buffer;

            function bufferedUpdate() {
                $timeout.cancel(buffer);
                $timeout(update, 20);
            }


            function update() {

                var start = scope.startDate,
                    suspended = scope.daysSuspended,
                    hours = scope.hours,
                    expected = scope.expectedHours;


                scope.scheduledEnd = scheduledEndDate(moment, start, suspended);
                scope.monthCount = calculateExpectedMonths(moment, start, suspended);
                scope.daysEarning = daysEarning(moment, start, scope.scheduledEnd,
                                                hours,suspended);

                scope.daysRemaining = Math.max(0, scope.scheduledEnd.diff(moment(), 'days'));

                scope.totalHours = sumHours(hours, scope.monthCount);
                scope.hoursLeft = Math.max(0, expected - scope.totalHours);

                scope.daysPerHour = scope.totalHours > 0
                    ? (scope.daysEarning / scope.totalHours)
                    : undefined;

                scope.projectedDays = scope.daysPerHour
                    ? scope.hoursLeft * scope.daysPerHour
                    : undefined;

                scope.projectedEndDate = scope.projectedDays
                    ? moment(start).add(scope.daysEarning + scope.projectedDays, 'days')
                    : undefined;

                scope.onTrack = scope.projectedEndDate &&
                    ! scope.projectedEndDate.isAfter(scope.scheduledEnd);
            }

            scope.$watchCollection('hours', bufferedUpdate);
            scope.$watchGroup(['startDate', 'daysSuspended', 'expectedHours'],
                              bufferedUpdate)

        },
    };

});

function addWatchers(moment, scope, startDatePath, suspendedPath, hoursPath) {

    scope.$watchGroup([startDatePath, suspendedPath], function(values) {
        scope.monthCount = calculateExpectedMonths(moment, values[0], values[1]);
    });

    scope.$watchGroup([startDatePath, 'monthCount'], function(values) {
        scope.months = buildMonthArray(moment, values[0], values[1]);
    });

    function updateTotalHours() {
        scope.totalHours = sumHours(scope.$eval(hoursPath), scope.monthCount);
    }

    scope.$watch('monthCount', updateTotalHours);
    scope.$watchCollection(hoursPath, updateTotalHours);
}

function scheduledEndDate(moment, startDate, daysSuspended) {
    daysSuspended = daysSuspended || 0;
    return moment(startDate).add(12, "months").subtract(1, 'day').add(daysSuspended, 'days');
}

function daysEarning(moment, startDate, endDate, hours, daysSuspended) {
    var i, projectedEnd;

    for (i = hours.length - 1; i >= 0; i--) {
        if (hours[i] || hours[i] === 0) {
            break;
        }
    }

    projectedEnd = moment(startDate).date(1).add(i + 1, 'months').date(0);
    endDate = moment.min(moment(), endDate, projectedEnd);
    return endDate.diff(startDate, 'days') - daysSuspended;
}

function calculateExpectedMonths(moment, startDate, daysSuspended) {
    var endDate;

    if (moment().isBefore(startDate)) {
        return 0;
    }

    daysSuspended = daysSuspended || 0;
    startDate = moment(startDate);
    endDate = moment(startDate)
        .add(12, "months")
        .subtract(1, "day")
        .add(daysSuspended, 'days');

    endDate = moment.min(moment(), endDate);

    return 12 * (endDate.year() - startDate.year()) +
        (endDate.month() - startDate.month()) + 1;
}

function buildMonthArray(moment, startDate, monthCount) {
    var i, months = [];
    startDate = moment(startDate);

    for (i = 0; i < monthCount; i++) {
        months.push(startDate.format('MMMM YYYY'));
        startDate.add(1, 'month');
    }

    return months;
}

function sumHours(hours, monthCount) {
    return (hours || []).reduce(function(a, b, i) {
        return a + (i < monthCount ? b || 0 : 0);
    }, 0);
}